// Путь: D:\QR\QR-WEB\dashboard\src\components\User\UserWithdraw.jsx
// Название: User Spend Component - Clean UI
// Версия: 5.0.0
// Дата: 09.01.2026

import React, { useState, useEffect } from 'react';
import './UserWithdraw.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://qr-money.onrender.com';

// Gift Cards (EUR)
const GIFT_CARDS = [
  { id: 'amazon', name: 'Amazon', icon: '🛒', amounts: [10, 25, 50, 100], fee: 3 },
  { id: 'itunes', name: 'iTunes / App Store', icon: '🍎', amounts: [10, 25, 50, 100], fee: 3 },
  { id: 'google', name: 'Google Play', icon: '▶️', amounts: [10, 25, 50, 100], fee: 3 },
  { id: 'spotify', name: 'Spotify', icon: '🎵', amounts: [10, 30, 60], fee: 3 },
  { id: 'netflix', name: 'Netflix', icon: '🎬', amounts: [15, 30, 50], fee: 3 },
  { id: 'zalando', name: 'Zalando', icon: '👗', amounts: [25, 50, 100], fee: 3 },
];

// Mobile Top-up
const MOBILE_OPERATORS = [
  { id: 'vodafone', name: 'Vodafone', icon: '📶', amounts: [5, 10, 20, 50], fee: 2 },
  { id: 'orange', name: 'Orange', icon: '🍊', amounts: [5, 10, 20, 50], fee: 2 },
  { id: 'tmobile', name: 'T-Mobile', icon: '📱', amounts: [5, 10, 20, 50], fee: 2 },
  { id: 'o2', name: 'O2', icon: '💨', amounts: [5, 10, 20, 50], fee: 2 },
];

// Gaming
const GAMING_PLATFORMS = [
  { id: 'steam', name: 'Steam Wallet', icon: '🎮', amounts: [10, 20, 50, 100], fee: 3 },
  { id: 'playstation', name: 'PlayStation Store', icon: '🎯', amounts: [10, 25, 50, 100], fee: 3 },
  { id: 'xbox', name: 'Xbox Gift Card', icon: '🟢', amounts: [10, 25, 50, 100], fee: 3 },
  { id: 'nintendo', name: 'Nintendo eShop', icon: '🔴', amounts: [15, 25, 50], fee: 3 },
  { id: 'roblox', name: 'Roblox', icon: '🧱', amounts: [10, 25, 50], fee: 5 },
  { id: 'fortnite', name: 'Fortnite V-Bucks', icon: '🎯', amounts: [10, 25, 50, 100], fee: 5 },
];

const UserWithdraw = () => {
  const [activeSection, setActiveSection] = useState(null); // null, 'giftcards', 'mobile', 'gaming', 'brandstore'
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [balance, setBalance] = useState(0);
  
  // Brand Store
  const [brandBalances, setBrandBalances] = useState([]);
  const [totalBrandDar, setTotalBrandDar] = useState(0);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [brandProducts, setBrandProducts] = useState([]);
  const [brandBalance, setBrandBalance] = useState(null);
  
  // Для gift cards / mobile / gaming
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [email, setEmail] = useState('');

  useEffect(() => {
    fetchBalance();
    fetchBrandBalances();
  }, []);

  const fetchBalance = async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) return;
      const payload = JSON.parse(atob(token.split('.')[1]));
      const userId = payload.userId;
      const response = await fetch(`${API_URL}/api/balance/${userId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (data.success && data.data) {
        setBalance(parseFloat(data.data.available_amount || data.data.amount) || 0);
      }
    } catch (err) {
      console.error('Error fetching balance:', err);
    }
  };

  const fetchBrandBalances = async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) return;
      const response = await fetch(`${API_URL}/api/brand-store/my-balances`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (data.success) {
        const withBalance = (data.data.balances || []).filter(b => parseFloat(b.amount) > 0);
        setBrandBalances(withBalance);
        setTotalBrandDar(parseFloat(data.data.totalBrandDar || 0));
      }
    } catch (err) {
      console.error('Error fetching brand balances:', err);
    }
  };

  const fetchBrandProducts = async (slug) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_URL}/api/brand-store/brand/${slug}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (data.success) {
        setBrandProducts(data.data.products || []);
        setBrandBalance(data.data.balance);
      }
    } catch (err) {
      console.error('Error fetching brand products:', err);
    }
  };

  const handleBrandSelect = (brand) => {
    setSelectedBrand(brand);
    setSelectedProduct(null);
    fetchBrandProducts(brand.brand_slug);
  };

  const handleBrandPurchase = async (product) => {
    const price = parseFloat(product.price_dar);
    if (!brandBalance || brandBalance.amount < price) {
      setError(`Недостаточно средств. Доступно: ${brandBalance?.amount?.toFixed(2) || 0} DAR`);
      return;
    }

    if (!window.confirm(`Купить "${product.name}" за ${price.toFixed(2)} DAR (€${price.toFixed(2)})?`)) return;

    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_URL}/api/brand-store/purchase`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ productId: product.id, quantity: 1 })
      });
      const data = await response.json();
      if (data.success) {
        setSuccess(`🎉 Покупка успешна! Код: ${data.data.redemptionCode}`);
        fetchBrandBalances();
        fetchBrandProducts(selectedBrand.brand_slug);
      } else {
        setError(data.error || 'Ошибка покупки');
      }
    } catch (err) {
      setError('Ошибка сети');
    } finally {
      setLoading(false);
    }
  };

  const getProductsList = () => {
    if (activeSection === 'giftcards') return GIFT_CARDS;
    if (activeSection === 'mobile') return MOBILE_OPERATORS;
    if (activeSection === 'gaming') return GAMING_PLATFORMS;
    return [];
  };

  const getSectionTitle = () => {
    if (activeSection === 'giftcards') return 'Подарочные карты';
    if (activeSection === 'mobile') return 'Пополнение мобильного';
    if (activeSection === 'gaming') return 'Игровые валюты';
    return '';
  };

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async () => {
    if (loading) return;
    
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      await new Promise(r => setTimeout(r, 1500));
      
      setSuccess(`🎉 Код ${selectedProduct?.name} €${selectedAmount} отправлен на ${email}!`);
      setSelectedProduct(null);
      setSelectedAmount(null);
      setEmail('');
      fetchBalance();
    } catch (err) {
      setError(err.message || 'Ошибка');
    } finally {
      setLoading(false);
    }
  };

  const goBack = () => {
    setActiveSection(null);
    setSelectedProduct(null);
    setSelectedBrand(null);
    setError(null);
    setSuccess(null);
  };

  const getBrandColor = (color) => {
    if (!color || color === '#000000' || color === '#111111') return '#6366F1';
    return color;
  };

  const freeDar = Math.max(0, balance - totalBrandDar);

  // ============================================
  // MAIN MENU VIEW
  // ============================================
  if (!activeSection) {
    return (
      <div className="spend-page">
        {/* Compact Balance */}
        <div className="balance-compact">
          <div className="balance-row">
            <span className="balance-total">{balance.toFixed(2)} DAR</span>
            <span className="balance-euro">= €{balance.toFixed(2)}</span>
          </div>
          <div className="balance-split">
            <span className="split-free">● Free: {freeDar.toFixed(2)}</span>
            <span className="split-brand">● Brand: {totalBrandDar.toFixed(2)}</span>
          </div>
        </div>

        {/* Spend Free DAR */}
        <div className="section-block">
          <h3>💸 Потратить Free DAR</h3>
          <div className="menu-grid">
            <div className="menu-card" onClick={() => setActiveSection('giftcards')}>
              <span className="menu-icon">🎁</span>
              <span className="menu-title">Gift Cards</span>
              <span className="menu-desc">Amazon, iTunes, Netflix...</span>
            </div>
            <div className="menu-card" onClick={() => setActiveSection('mobile')}>
              <span className="menu-icon">📱</span>
              <span className="menu-title">Мобильный</span>
              <span className="menu-desc">Пополнение связи</span>
            </div>
            <div className="menu-card" onClick={() => setActiveSection('gaming')}>
              <span className="menu-icon">🎮</span>
              <span className="menu-title">Игры</span>
              <span className="menu-desc">Steam, PlayStation, Xbox...</span>
            </div>
          </div>
        </div>

        {/* Brand Store Link */}
        {totalBrandDar > 0 && (
          <div className="section-block">
            <h3>🏪 Brand Store</h3>
            <div className="brand-link-card" onClick={() => window.location.href = '/brand-store'}>
              <span className="brand-link-icon">🛍️</span>
              <div className="brand-link-info">
                <span className="brand-link-title">Перейти в Brand Store</span>
                <span className="brand-link-balance">Доступно: {totalBrandDar.toFixed(2)} Brand DAR</span>
              </div>
              <span className="brand-link-arrow">→</span>
            </div>
          </div>
        )}
      </div>
    );
  }

  // ============================================
  // GIFT CARDS / MOBILE / GAMING VIEW
  // ============================================
  return (
    <div className="spend-page">
      <button className="btn-back" onClick={goBack}>← Назад</button>

      {error && <div className="alert alert-error">❌ {error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <div className="section-header">
        <h2>{getSectionTitle()}</h2>
        <span className="available-balance">Доступно: {freeDar.toFixed(2)} DAR</span>
      </div>

      {!selectedProduct ? (
        <div className="products-grid-full">
          {getProductsList().map(product => (
            <div
              key={product.id}
              className="product-card-full"
              onClick={() => setSelectedProduct(product)}
            >
              <span className="product-icon-lg">{product.icon}</span>
              <span className="product-name">{product.name}</span>
              <span className="product-fee">{product.fee}% комиссия</span>
            </div>
          ))}
        </div>
      ) : (
        <div className="purchase-flow">
          <div className="selected-product">
            <span className="product-icon-lg">{selectedProduct.icon}</span>
            <span className="product-name-lg">{selectedProduct.name}</span>
            <button className="btn-change" onClick={() => setSelectedProduct(null)}>Изменить</button>
          </div>

          <div className="form-section">
            <label>Выберите номинал</label>
            <div className="amounts-row">
              {selectedProduct.amounts.map(amt => {
                const totalCost = amt + (amt * selectedProduct.fee / 100);
                const disabled = totalCost > freeDar;
                return (
                  <button
                    key={amt}
                    className={`amount-btn ${selectedAmount === amt ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
                    onClick={() => !disabled && setSelectedAmount(amt)}
                    disabled={disabled}
                  >
                    <span className="amt-value">€{amt}</span>
                    <span className="amt-cost">{totalCost.toFixed(2)} DAR</span>
                  </button>
                );
              })}
            </div>
          </div>

          {selectedAmount && (
            <div className="form-section">
              <label>Email для получения кода</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="input-email"
              />
            </div>
          )}

          {selectedAmount && email && isValidEmail(email) && (
            <div className="summary-box">
              <div className="summary-row">
                <span>{selectedProduct.name}</span>
                <strong>€{selectedAmount}</strong>
              </div>
              <div className="summary-row">
                <span>Комиссия ({selectedProduct.fee}%)</span>
                <strong>{(selectedAmount * selectedProduct.fee / 100).toFixed(2)} DAR</strong>
              </div>
              <div className="summary-row total">
                <span>Итого</span>
                <strong>{(selectedAmount * (1 + selectedProduct.fee / 100)).toFixed(2)} DAR</strong>
              </div>
            </div>
          )}

          <button 
            onClick={handleSubmit}
            disabled={loading || !selectedAmount || !isValidEmail(email)}
            className="btn-purchase"
          >
            {loading ? '⏳ Обработка...' : `Получить ${selectedProduct.name}`}
          </button>
        </div>
      )}
    </div>
  );
};

export default UserWithdraw;